<template>
  <table class="table table-bordered">
      <thead class="thead-dark">
        <tr>
          <th class="text-center">ID</th>
          <th class="text-center">Start Time</th>
          <th class="text-center">End Time</th>
          <th class="text-center">Distance<br />(KM)</th>
          <th class="text-center">Fuel<br />(Litres)</th>
          <th class="text-center">Emission<br />(CO2)</th>
          <th class="text-center">Fuel Cost</th>
          <th class="text-center">Economy<br />(L/100KM)</th>
          <th class="text-center">Average Speed</th>
          <th class="text-center">Trip Details</th>
          <th class="text-center">Events</th>
          <th class="text-center">Device</th>
          <th class="text-center">Firmware Version</th>
          <th class="text-center">Mobile App Version</th>
          <th class="text-center">Mobile Handset</th>
          <th class="text-center">Ray</th>
          <th class="text-center">Calibration</th>
          <!-- <th class="text-center">Manual<br/>Tags</th>
        <th class="text-center">Predicted<br/>Tags</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="trip in tripsWithManualAndPredictedTags" :key="trip.id">
          <td>{{ trip.id }}</td>
          <td>{{ trip.startTime }}<br /><br />[{{ trip.startTimeZone }}]</td>
          <td>{{ trip.endTime }}<br /><br />[{{ trip.endTimeZone }}]</td>
          <td>{{ trip.distance }}</td>
          <td>{{ trip.litres }}</td>
          <td>{{ trip.co2 }}</td>
          <td>{{ trip.fuelCost }}</td>
          <td>{{ trip.litresPerHundredKm }}</td>
          <td>{{ trip.averageSpeed }}</td>
          <td>{{ trip.numberOfTripDetails }}</td>
          <td>{{ trip.numberOfEvents }}</td>
          <td>{{ trip.deviceSerialNumber }}</td>
          <td>{{ trip.firmwareVersion }}</td>
          <td>{{ trip.MobileAppVersion }}</td>
          <td>{{ trip.mobileHandset }}</td>
          <td><input class="form-check-input" type="checkbox" :checked="!trip.rayNotConnected" disabled /></td>
          <td><input class="form-check-input" type="checkbox" :checked="trip.calibrationRunning" disabled /></td>
        </tr>
      </tbody>
    </table>
</template>

<script>
export default {
  name: 'VehicleTripsTabular',
  props: {
    tripsWithManualAndPredictedTags:[]
  }
}
</script>
